export default __webpack_public_path__ + "static/media/sputnic.3e886ab5.svg";